module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vh-100 overflow-y-scroll"
  }, [_c('div', {
    staticClass: "ma2"
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n      Go back\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "ma4 mw8 center"
  }, [_c('h1', [_vm._v("Teacher: " + _vm._s(_vm.user.name))]), _vm._v(" "), _c('h1', [_vm._v("Email: " + _vm._s(_vm.user.email))]), _vm._v(" "), _c('h1', [_vm._v("\n      Role: " + _vm._s(_vm.user.role) + "\n      "), _c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.changeUserRole.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        Change to\n        " + _vm._s(_vm.user.role === 'teacher' ? 'student' : 'teacher') + "\n      ")])], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.user.role === 'teacher') ? [_c('h2', [_vm._v("Active Memberships")]), _vm._v(" "), _c('ul', _vm._l((_vm.active_memberships), function(membership) {
    return _c('li', {
      staticClass: "pl-subheading"
    }, [_c('strong', [_vm._v("Expiry Date")]), _vm._v(": " + _vm._s(membership.end_date_readable) + "\n          "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Date Started")]), _vm._v(": " + _vm._s(membership.start_date_readable) + "\n          "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Membership Type")]), _vm._v(": " + _vm._s(membership.membership.type) + "\n        ")])
  }), 0), _vm._v(" "), _c('h2', [_vm._v("Previous (Expired) Memberships")]), _vm._v(" "), _c('ul', _vm._l((_vm.expired_memberships), function(membership) {
    return _c('li', {
      staticClass: "pl-subheading"
    }, [_c('strong', [_vm._v("Expiry Date")]), _vm._v(": " + _vm._s(membership.end_date_readable) + "\n          "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Date Started")]), _vm._v(": " + _vm._s(membership.start_date_readable) + "\n          "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Membership Type")]), _vm._v(": " + _vm._s(membership.membership.type) + "\n        ")])
  }), 0), _vm._v(" "), _c('h2', [_vm._v("Create New Membership")]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Choose Membership Duration")]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "start"
    }
  }, [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.start_date),
      expression: "start_date"
    }],
    attrs: {
      "type": "date",
      "id": "start",
      "name": "membership-selection",
      "required": ""
    },
    domProps: {
      "value": (_vm.start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "end"
    }
  }, [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.end_date),
      expression: "end_date"
    }],
    attrs: {
      "type": "date",
      "id": "end",
      "name": "membership-selection",
      "required": ""
    },
    domProps: {
      "value": (_vm.end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.end_date = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('pl-button', {
    staticClass: "pl-primary",
    attrs: {
      "disabled": Boolean(!(_vm.start_date && _vm.end_date))
    },
    nativeOn: {
      "click": function($event) {
        return _vm.createNewUserMembership.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          Create New\n        ")])], 1), _vm._v(" "), _c('h2', [_vm._v("Activity Passes")]), _vm._v(" "), _c('div', {
    staticClass: "pl-subheading"
  }, [_c('div', [_vm._v("Current Unused passes: " + _vm._s(_vm.user.activity_passes))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passes_to_create),
      expression: "passes_to_create"
    }],
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.passes_to_create)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passes_to_create = $event.target.value
      }
    }
  }), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.createActivityPasses.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          Create More\n        ")])], 1)] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-7ed091e2!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/viewIndividualUser.vue
// module id = 1997
// module chunks = 61